/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Rellax from "rellax";

/*------------------------------------*\
    HOME BACKGROUND
\*------------------------------------*/
class HomeBackground {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const rellax = new Rellax(self.elem, {
            speed: -4.8
        });
    }

}

export default HomeBackground;
